/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-menu': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M2 14.8h16V16H2v-1.2zm0-3.6h16v1.2H2v-1.2zm0-3.6h16v1.2H2V7.6zM2 4h16v1.2H2V4z"/>'
  }
})
